import React from "react";

const KampanjaFlow = () => {
  const publicUrl = process.env.PUBLIC_URL + "/";

  return (
    <div className="kampanja-flow-area pd-top-80 pd-bottom-70">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-title text-center">
              <h2 className="title">
                Jedna kampanja, <span>dva kanala</span>
              </h2>
              <p>
                Ista poruka ide na Google, društvene mreže i na plohu uz cestu.
                Tako klijenti vide brend i kad traže online, i kad prolaze
                gradom.
              </p>
            </div>
          </div>
        </div>

        <div className="kampanja-flow">
          <div className="kampanja-flow-step">
            <span className="kampanja-flow-num">01</span>
            <h4>Brief i cilj</h4>
            <p>Što želite: upiti, prodaja ili prepoznatljivost brenda.</p>
          </div>

          <div className="kampanja-flow-arrow" aria-hidden="true">
            <i className="fa fa-long-arrow-right" />
          </div>

          <div className="kampanja-flow-split">
            <div className="kampanja-flow-channel">
              <div className="kampanja-flow-thumb">
                <img
                  src={publicUrl + "assets/img/card-digital.png"}
                  alt="Digitalni marketing: SEO, Google Ads i društvene mreže"
                />
              </div>
              <div className="kampanja-flow-channel-body">
                <span className="kampanja-flow-num">02</span>
                <h4>Digitalno</h4>
                <p>SEO, Google Ads, društvene mreže i web.</p>
              </div>
            </div>
            <div className="kampanja-flow-plus" aria-hidden="true">
              +
            </div>
            <div className="kampanja-flow-channel">
              <div className="kampanja-flow-thumb">
                <img
                  src={publicUrl + "assets/img/card-outdoor.png"}
                  alt="Vanjsko oglašavanje: billboardi i city lightovi"
                />
              </div>
              <div className="kampanja-flow-channel-body">
                <span className="kampanja-flow-num">03</span>
                <h4>Vanjsko</h4>
                <p>Billboardi, city lightovi, wallscape i putokazi.</p>
              </div>
            </div>
          </div>

          <div className="kampanja-flow-arrow" aria-hidden="true">
            <i className="fa fa-long-arrow-right" />
          </div>

          <div className="kampanja-flow-step">
            <span className="kampanja-flow-num">04</span>
            <h4>Rezultati</h4>
            <p>Ista priča online i na ulici, uz brojke koje se mjere.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KampanjaFlow;
